// Arabic
export default {
  resdoc_title: "دليل لوحة تحكم المطعم",
  resdoc_subtitle:
    "كل ما تحتاجه لإدارة عمليات مطعمك بسهولة وكفاءة.",

  resdoc_profile_title: "إعداد ملف المطعم",
  resdoc_profile_1: "اسم المطعم وبيانات الاتصال",
  resdoc_profile_2: "العنوان ومنطقة الخدمة",
  resdoc_profile_3: "أوقات الفتح والإغلاق",
  resdoc_profile_4: "بيانات الضريبة والتراخيص والبنك",
  resdoc_profile_5: "إعدادات توفر القائمة",

  resdoc_dashboard_title: "نظرة عامة على اللوحة",
  resdoc_dashboard_1: "طلبات اليوم والإيرادات",
  resdoc_dashboard_2: "إجمالي العملاء المخدومين",
  resdoc_dashboard_3: "متوسط تقييم العملاء",
  resdoc_dashboard_4: "تفاصيل حالات الطلبات",
  resdoc_dashboard_5: "تحليلات واتجاهات المبيعات",

  resdoc_menu_title: "إدارة القائمة",
  resdoc_menu_1: "إضافة أو تعديل أو تعطيل الأصناف",
  resdoc_menu_2: "تحديد الأسعار والصور والفئات",
  resdoc_menu_3: "إدارة توفر الأصناف",
  resdoc_menu_4: "إنشاء العروض والوجبات الخاصة",

  resdoc_orders_title: "إدارة الطلبات",
  resdoc_orders_1: "قبول أو رفض الطلبات الواردة",
  resdoc_orders_2: "تعديل الطلبات عند الحاجة",
  resdoc_orders_3: "تحديث حالة تجهيز الطلب",
  resdoc_orders_4: "متابعة اكتمال التوصيل",

  resdoc_issue_title: "المطبخ ومشاكل الطلبات",
  resdoc_issue_1: "إرسال المشاكل إلى فريق المطبخ",
  resdoc_issue_2: "معالجة الأصناف المفقودة أو المعدلة",
  resdoc_issue_3: "حل شكاوى العملاء",
  resdoc_issue_4: "تحسين جودة الخدمة",

  resdoc_inventory_title: "المخزون والمستودع",
  resdoc_inventory_1: "متابعة مخزون المواد الخام",
  resdoc_inventory_2: "منع النقص في المخزون",
  resdoc_inventory_3: "ربط المخزون بأصناف القائمة",
  resdoc_inventory_4: "الحفاظ على مستويات مخزون مثالية",

  resdoc_reports_title: "التقارير والتحليلات",
  resdoc_reports_1: "المبيعات اليومية والأسبوعية والشهرية",
  resdoc_reports_2: "الأطباق الأكثر مبيعًا",
  resdoc_reports_3: "تحليلات سلوك العملاء",
  resdoc_reports_4: "مؤشرات الأداء التشغيلي",

  resdoc_help_title: "الجولات الإرشادية والمساعدة",
  resdoc_help_1: "شروحات خطوة بخطوة للوحة التحكم",
  resdoc_help_2: "إرشادات أدوات القائمة والطلبات",
  resdoc_help_3: "تهيئة سهلة للمبتدئين",

  resdoc_footer:
    "مصمم لمساعدة مطعمك على النمو بشكل أسرع وتقديم خدمة أفضل",
};